import moment from "moment";
import { useEffect, useRef, useState } from "react";
import { Col, Modal, Row, Table } from "react-bootstrap";
import Button from "react-bootstrap/Button";
import Card from "react-bootstrap/Card";
import Form from "react-bootstrap/Form";
import ReactDOMServer from "react-dom/server";
import Swal from 'sweetalert2';
import { PositionServices } from "../../services/PositionServices";
import { ownSubscribe, sendMessage, unSubscribe } from '../../stomp/StompSocket';
import * as BullCache from "../../util/BullCache";
import AdminDropdown from "../components/AdminDropdown";
import BrokerDropdown from "../components/BrokerDropdown";
import ClientDropdown from "../components/ClientDropdown";
import MarketDropdown from "../components/MarketDropdown";
import MasterDropdown from "../components/MasterDropdown";
import NumberFormatter from "../components/NumberFormatter";
import ScriptDropdown from "../components/ScriptDropdown";
import { customStyles, the } from '../components/customStyles';

function Position() {
  
  const [loading, setLoading] = useState(false); 
  const [selectedAdmin, setSelectedAdmin] = useState(null);
  const selectedAdminRef = useRef(selectedAdmin);
  const [selectedMaster, setSelectedMaster] = useState(null);
  const selectedMasterRef = useRef(selectedMaster);
  const [selectedSubBrokerId, setSelectedSubBrokerId] = useState(null);
  const selectedSubBrokerRef = useRef(selectedSubBrokerId);
  const [selectedClient, setSelectedClient] = useState(null);
  const selectedClientRef = useRef(selectedClient);
  const [selectedMarket, setSelectedMarket] = useState(null);
  const selectedMarketRef = useRef(selectedMarket);
  const [selectedScript, setSelectedScript] = useState(null);
  const selectedScriptRef = useRef(selectedScript);
  const [fromDate, setFromDate] = useState("");
  const [selectedBrokerId, setSelectedBrokerId] = useState(null);
  const selectedBrokerRef = useRef(selectedBrokerId);
  const [positionList, setPositionList] = useState([]);
  //var [flattenedPositions, setFlattenedPositions] = useState([]);
  const [watchScripts, setWatchScripts] = useState([]);
  const [checkboxState, setCheckboxState] = useState({});
  const [isAllSelected, setIsAllSelected] = useState(false);
  const [errors, setErrors] = useState(false);

  var user = BullCache.getFromCache("user");
  var allScripts = BullCache.getFromCache('allScripts');

  const [totalMTM, setTotalMTM] = useState(0);
  const [totalBuyQty, setTotalBuyQty] = useState(0);
  const [totalSellQty, setTotalSellQty] = useState(0);
  const [totalQty, setTotalQty] = useState(0);
  const [downMTM, setDownMTM] = useState(0);
  const [selfMTM, setSelfMTM] = useState(0);
  const [upMTM, setUpMTM] = useState(0);
  const [adminPartnership, setAdminPartnership] = useState(0);
  const [masterPartnership, setMasterPartnership] = useState(0);
  const [brokerPartnership, setBrokerPartnership] = useState(0);
  const [subBrokerPartnership, setSubBrokerPartnership] = useState(0);

  const [positionMap, setPositionMap] = useState([]);
  var [first, setFirst] = useState();
  const [selectedRowData, setSelectedRowData] = useState(null);
  const [selectedRowData2, setSelectedRowData2] = useState(null);
  const [orderType, setOrderType] = useState("MARKET");
  const [showModal, setShowModal] = useState(false);
  const [status, setStatus] = useState('ALL');
  const [showPositionModal, setShowPositionModal] = useState(false);
  const handlePositionModalClose = () => {setShowPositionModal(false); 
    setSelectedRowData({}); setSelectedRowData2({})};

useEffect(() => {
  if (status === 'ALL') {

    getPosition(true);

  } else {
    setLoading(true);
      const outstandingPosition = positionList
      .map(position => {
        const filtered = position.position.filter(p => p.lot !== 0);
        return filtered.length > 0 ? { ...position, position: filtered } : null;
      })
      .filter(Boolean); // Remove nulls

      flattenPositionData(outstandingPosition);
    setLoading(false);
  };

  const updatePositionFromTrade = (trade) => {
    if (!trade.userId || !trade.scriptId) return;

    const isFilterActive = selectedClientRef.current || selectedBrokerRef.current || selectedMasterRef.current || selectedAdminRef.current
      || selectedMarketRef.current || selectedScriptRef.current;

    const scriptNameParts = (trade.scriptNameRaw || '').split('#');
    const tradeSegment = scriptNameParts[0] || '';
    const tradeSymbol = scriptNameParts[1] || '';

    if (selectedMarketRef.current && tradeSegment !== selectedMarketRef.current) return;
    if (selectedScriptRef.current && tradeSymbol !== selectedScriptRef.current) return;

    const isBuy = trade.orderType && trade.orderType.toUpperCase().includes('BUY');
    const tradeQty = trade.quantity || 0;
    const tradeLot = trade.lot || 0;
    const tradeNetRate = parseFloat(trade.netRate || trade.rate || 0);
    const tradeValue = tradeNetRate * tradeQty;

    setPositionMap((prevMap) => {
      let userFound = false;
      let scriptFound = false;

      const updatedMap = prevMap.map((pp) => {
        if (pp.userId !== trade.userId) return pp;

        userFound = true;

        const updatedFlattened = pp.flattened.map((mkw) => {
          if (mkw.scriptId !== trade.scriptId) return mkw;

          scriptFound = true;

          let newTotalBuy = parseFloat(mkw.totalBuy) || 0;
          let newTotalSell = parseFloat(mkw.totalSell) || 0;
          let newTotalBuyQty = parseInt(mkw.totalBuyQty) || 0;
          let newTotalSellQty = parseInt(mkw.totalSellQty) || 0;
          let newTotalBuyLot = parseFloat(mkw.totalBuyLot) || 0;
          let newTotalSellLot = parseFloat(mkw.totalSellLot) || 0;

          if (isBuy) {
            newTotalBuy += tradeValue;
            newTotalBuyQty += tradeQty;
            newTotalBuyLot += tradeLot;
          } else {
            newTotalSell += tradeValue;
            newTotalSellQty += tradeQty;
            newTotalSellLot += tradeLot;
          }

          const newQty = newTotalBuyQty - newTotalSellQty;
          const newType = newTotalBuy >= newTotalSell ? 'Buy' : 'Sell';
          const netQty = Math.abs(newQty);
          const newAverage = netQty === 0 ? 0
            : (newType === 'Buy'
              ? (newTotalBuy - newTotalSell) / netQty
              : (newTotalSell - newTotalBuy) / netQty);
          const newLot = newTotalBuyLot - newTotalSellLot;

          const newProfitLoss = newQty !== 0
            ? (parseFloat(mkw.ltp) - newAverage) * newQty
            : (newTotalSell - newTotalBuy);

          return {
            ...mkw,
            totalBuy: newTotalBuy,
            totalSell: newTotalSell,
            totalBuyQty: newTotalBuyQty,
            totalSellQty: newTotalSellQty,
            totalBuyLot: newTotalBuyLot,
            totalSellLot: newTotalSellLot,
            qty: newQty,
            bea: newAverage,
            type: newType,
            lot: newLot,
            profitLoss: newProfitLoss,
          };
        });

        if (!scriptFound) {
          const scriptNameParts = (trade.scriptNameRaw || '').split('#');
          const segment = scriptNameParts[0] || '';
          const newQty = isBuy ? tradeQty : -tradeQty;
          const newType = isBuy ? 'Buy' : 'Sell';
          const newLot = isBuy ? tradeLot : -tradeLot;

          updatedFlattened.push({
            userId: trade.userId,
            scriptId: trade.scriptId,
            segment: segment,
            scriptName: trade.script || '',
            totalBuy: isBuy ? tradeValue : 0,
            totalBuyQty: isBuy ? tradeQty : 0,
            totalBuyLot: isBuy ? tradeLot : 0,
            totalSell: !isBuy ? tradeValue : 0,
            totalSellQty: !isBuy ? tradeQty : 0,
            totalSellLot: !isBuy ? tradeLot : 0,
            qty: newQty,
            bea: tradeNetRate,
            ltp: parseFloat(trade.rate) || 0,
            type: newType,
            lot: newLot,
            profitLoss: 0,
            client: trade.userName || '',
            icon: ReactDOMServer.renderToString(
              <span className="fa fa-close nagative-amout-color" style={{ cursor: "pointer" }} size="sm"></span>
            ),
          });
        }

        const newTotalMTM = updatedFlattened.reduce((sum, f) => sum + f.profitLoss, 0);

        return {
          ...pp,
          flattened: updatedFlattened,
          totalMTM: newTotalMTM,
        };
      });

      if (!userFound && !isFilterActive) {
        const scriptNameParts = (trade.scriptNameRaw || '').split('#');
        const segment = scriptNameParts[0] || '';
        const newQty = isBuy ? tradeQty : -tradeQty;
        const newType = isBuy ? 'Buy' : 'Sell';
        const newLot = isBuy ? tradeLot : -tradeLot;

        const newEntry = {
          userId: trade.userId,
          name: trade.userName || '',
          subBrokerPartnership: 0,
          totalMTM: 0,
          flattened: [{
            userId: trade.userId,
            scriptId: trade.scriptId,
            segment: segment,
            scriptName: trade.script || '',
            totalBuy: isBuy ? tradeValue : 0,
            totalBuyQty: isBuy ? tradeQty : 0,
            totalBuyLot: isBuy ? tradeLot : 0,
            totalSell: !isBuy ? tradeValue : 0,
            totalSellQty: !isBuy ? tradeQty : 0,
            totalSellLot: !isBuy ? tradeLot : 0,
            qty: newQty,
            bea: tradeNetRate,
            ltp: parseFloat(trade.rate) || 0,
            type: newType,
            lot: newLot,
            profitLoss: 0,
            client: trade.userName || '',
            icon: ReactDOMServer.renderToString(
              <span className="fa fa-close nagative-amout-color" style={{ cursor: "pointer" }} size="sm"></span>
            ),
          }],
        };

        return [...updatedMap, newEntry];
      }

      return updatedMap;
    });
  };

  const subscribeSocket = () => {
            ownSubscribe('/topic/dash/' + user.adminId, function (msg) {
                var trade = JSON.parse(msg.body);
                if(trade){
                    if(trade.tradeType === 'EXECUTED'){
                       updatePositionFromTrade(trade);
                    }
                }
            }, 'dash-subscribe-id2')
            };

    const timeoutId = setTimeout(() => {
         componentWillUnmount2();
            subscribeSocket();
   
    }, 2000);
    
    return () => {
        clearTimeout(timeoutId); 
      //  clearInterval(intervalId); 
        componentWillUnmount2();
    };

}, [status]); 

  const componentWillUnmount2 = () => {
    unSubscribe('dash-subscribe-id2');
  }

  useEffect(() => {
  selectedAdminRef.current = selectedAdmin;
}, [selectedAdmin]);

useEffect(() => {
  selectedMasterRef.current = selectedMaster
}, [selectedMaster]);

useEffect(() => {
  selectedSubBrokerRef.current = selectedSubBrokerId;
}, [selectedSubBrokerId]);

useEffect(() => {
  selectedBrokerRef.current = selectedBrokerId;
}, [selectedBrokerId]);

useEffect(() => {
  if(showModal) {
    selectedMarketRef.current = null;
    selectedScriptRef.current = null;
    selectedAdminRef.current = null;
    selectedMasterRef.current = null;
    selectedSubBrokerRef.current = null;
    selectedBrokerRef.current = null;
  }
}, [showModal]);

  const handleExitClick = (e, mkw1) => {
    const lot2 = mkw1.type === 'Buy' ? mkw1.totalBuyLot - mkw1.totalSellLot : mkw1.totalSellLot - mkw1.totalBuyLot;
    const qty2 = mkw1.type === 'Buy' ? mkw1.qty : 0 - mkw1.qty;
    
    setSelectedRowData({ ...mkw1, lot: lot2, qty: qty2 });
    setSelectedRowData2({ ...mkw1, lot: lot2 , qty: qty2});
    setShowPositionModal(true);
    setOrderType("MARKET");
  };

  const handleRadioSelection = (selection) => {
    setOrderType(selection);
    setSelectedRowData({ ...selectedRowData, ltp: selectedRowData2.ltp })
  };

  const onLotchange= (e) => {
    if(selectedRowData.lot !== e.target.value) { 
      var lot1 = e.target.value > 0 ? e.target.value : '';
      let updatedQty = selectedRowData.qty; // Default to current qty
      Object.entries(allScripts).forEach( ([segment, scripts] ) => {
        if(segment === selectedRowData.segment){
          Object.entries(scripts).forEach( ([symbol, script] ) => {
            if(selectedRowData2.scriptName.split(" ")[0] === symbol){
              updatedQty = lot1 * script[0].quantity;
            }
          })
        }
      });
      if((/^\d*$/.test(updatedQty))) {
        setSelectedRowData({ ...selectedRowData, qty: updatedQty, lot: lot1});
      } 
    }
  }

  const onQtychange= (e) => { 
    if(selectedRowData.qty !== e.target.value) { 
      var qty1 = e.target.value > 0 ? e.target.value : '';
      let updatedLot = selectedRowData.lot; 
      Object.entries(allScripts).forEach( ([segment, scripts] ) => {
        if(segment === selectedRowData.segment){
          Object.entries(scripts).forEach( ([symbol, script] ) => {
            if(selectedRowData2.scriptName.split(" ")[0] === symbol){
              updatedLot = qty1 / script[0].quantity ;
            }
          })
        }
      });

      if( (/^\d*$/.test(qty1))) {
        setSelectedRowData({ ...selectedRowData, qty: qty1, lot: updatedLot});
      }
    }
}

const handleBuySell = () => {
  //setShowPositionModal(false); 
  if(selectedRowData.lot === '' || selectedRowData.qty === ''){
        Swal.fire({
                icon: "warning",
                text: 'Lot and Quantity is required!'
              });
    } else if(orderType === 'LIMIT' && selectedRowData.ltp === '') {
     Swal.fire({
                icon: "warning",
                text: 'Price is required!'
              });
    } else {          
      Swal.fire({
        title: 'Are you sure?',
        icon: 'warning',
        showCancelButton: true,
        confirmButtonText: 'Yes ',
        cancelButtonText: 'No',
        cancelButtonColor: "#d33",
    }).then((result) => {
        if (result.isConfirmed) {

          var selectedPositionList = [];
          var type= '';
          var rate = selectedRowData2.ltp;
          if (orderType === 'LIMIT' ) {
            if(selectedRowData.type === 'Sell') {
              type = rate > selectedRowData.ltp ? 'Buy-RL' : 'Buy-SL';
            } else {
              type = rate < selectedRowData.ltp ? 'Sell-RL' : 'Sell-SL';
            }
          } else{
            type = selectedRowData.type === "Buy" ? "Sell-MP" : "Buy-MP"
          }

            var position = {
              scriptId : selectedRowData.scriptId,
              userId: selectedRowData.userId,
              tradeBy: user.adminId,
              orderType: type,
              quantity: selectedRowData.qty,
              lot: selectedRowData.lot,
              rate: selectedRowData.ltp,
              inLimit: false,
              device: "Browser",
              "userAgent": navigator.userAgent
            }
            selectedPositionList.push(position);

          
        exitPositionCall(selectedPositionList);
          
        }
      });
    }
};

  const flattenPositionData = (positions) => {
    setTotalMTM(0);
    setTotalBuyQty(0);
    setTotalSellQty(0);
    setTotalQty(0);
    setDownMTM(0);
    var mapList = [];

    positions.forEach((position) => {
      var client = position.user;
      var usertotalMTM = 0;
      var flattened = [];

      if (Array.isArray(position.position)) {
        setAdminPartnership(position.adminPartnership);
        setMasterPartnership(position.masterPartnership);
        setBrokerPartnership(position.brokerPartnership);
        setSubBrokerPartnership(position.subBrokerPartnership);

        position.position.forEach((script) => {
          usertotalMTM += script.profitLoss;
          var scriptName = script.scriptName.split("#");
          flattened.push({
            userId: client.userid,
            scriptId: script.scriptId,
            segment: scriptName[0],
            scriptName:
              scriptName[1] +
              " " +
              moment(scriptName[2], "DD/MM/YYYY").format("DDMMMYYYY").toUpperCase(),
            totalBuyQty: script.totalBuyQty,
            totalBuyLot: script.totalBuyLot,
            totalBuy: script.totalBuy,
            totalSellQty: script.totalSellQty,
            totalSellLot: script.totalSellLot,
            totalSell: script.totalSell,
            qty: script.totalBuyQty - script.totalSellQty,
            bea: script.average,
            ltp: parseFloat(script.ltp),
            type: script.type,
            profitLoss: script.profitLoss,
            client:
              position.user.firstName +
              " (" +
              client.userName +
              ") / "+ client.admin,
            icon: ReactDOMServer.renderToString(
              <span
                className="fa fa-close nagative-amout-color"
                style={{ cursor: "pointer" }}
                size="sm"
              ></span>
            ),
          });

          if (user.adminType !== 'SUBBROKER' && position.subBrokerPartnership && position.subBrokerPartnership > 0) {
            setDownMTM((prevDownMTM) => prevDownMTM + (script.profitLoss * (position.subBrokerPartnership / 100)));
          }
          setTotalMTM((prevTotalMTM) => prevTotalMTM + script.profitLoss);
          setTotalBuyQty((prevTotalBuyQty) => prevTotalBuyQty + parseInt(script.totalBuyQty));
          setTotalSellQty((prevTotalSellQty) => prevTotalSellQty + parseInt(script.totalSellQty));

          if (watchScripts[script.scriptId] === undefined) {
            watchScripts.push(script.scriptId);
          }

        });
      }

      const updatedFlattened = [...flattened];

      var postionMap1 = {
        userId: client.userid,
        name: client.firstName + " (" + client.userName + ")",
        subBrokerPartnership: position.subBrokerPartnership,
        totalMTM: usertotalMTM,
        flattened: updatedFlattened
      };

      mapList.push(postionMap1);

    });

    setPositionMap([...mapList]);
    return mapList;
  };

  useEffect(() => {
    const flattenedData = flattenPositionData(positionList);
    
    componentWillUnmount1();
    setTimeout(() => {
      subscribeWatch();
    }, 200);

  }, [positionList]);

  const componentWillUnmount1 = () => {
    unSubscribe('watch-subscribe-id1');
  }

  const subscribeWatch = () => {
    ownSubscribe('/topic/watch/' + user.adminId, function (msg) {

      if (msg.body) {

        if (first) {
          setFirst(false);
        } else {

          const updatedDataArray = JSON.parse(msg.body); // Parse the incoming message body
          
          setPositionMap((prevPositionMap) => {
            return prevPositionMap.map((pp) => {
              const updatedFlattened = pp.flattened.map((mkw) => {
             
                const updatedData = updatedDataArray.find(
                  (data) => data.id === mkw.scriptId
                );
             
                if (updatedData && ((mkw.type === 'Buy' && (parseFloat(updatedData.i2) > 0 || updatedData.i6)) || (mkw.type === 'Sell' && (parseFloat(updatedData.i4) > 0 || updatedData.i6) ))) {
                  return {
                    ...mkw,
                    ltp: mkw.type === 'Buy' ? (parseFloat(updatedData.i2) > 0 ? parseFloat(updatedData.i2) : parseFloat(updatedData.i6)) : (parseFloat(updatedData.i4) > 0 ? parseFloat(updatedData.i4) : parseFloat(updatedData.i6)),
                    profitLoss:
                      mkw.qty !== 0
                        ? ( (mkw.type === 'Buy' ? (parseFloat(updatedData.i2) > 0 ? parseFloat(updatedData.i2) : parseFloat(updatedData.i6)) : (parseFloat(updatedData.i4) > 0 ? parseFloat(updatedData.i4) : parseFloat(updatedData.i6))) - mkw.bea) * mkw.qty
                        : mkw.profitLoss,
                  };
                }

                return mkw; // Return unchanged if no updated data
              });

              // Return updated position object
              return {
                ...pp,
                flattened: updatedFlattened,
              };
            });
          });

          // setFlattenedPositions((prevPositions) =>
          //   prevPositions.map((mkw) => {
          //     const updatedData = updatedDataArray.find(
          //       (data) => data.id === mkw.scriptId
          //     );
          //     var newMkw = mkw;
          //     if (updatedData) {
          //       newMkw = mkw;
          //       newMkw.ltp = mkw.type === 'Buy' ? parseFloat(updatedData.i2) : parseFloat(updatedData.i4);
          //       newMkw.profitLoss = mkw.qty != 0 ? ( (mkw.type === 'Buy' ? parseFloat(updatedData.i2) : parseFloat(updatedData.i4)) - mkw.bea) * mkw.qty : mkw.profitLoss;
          //     }
          //     return newMkw;
          //   }));

        }
      }
    }, 'watch-subscribe-id1');

    const deduplicatedScripts = Array.from(new Set(watchScripts));
    setWatchScripts(deduplicatedScripts);
    if (deduplicatedScripts.length > 0) {
      sendMessage('/app/topic/watch/' + user.adminId, JSON.stringify(prepareFirstTimeRequest(deduplicatedScripts)));

      function prepareFirstTimeRequest(scripts) {
        return {
          'scripts': scripts, isMobile: true, data: {}, wantToStop: false, wantToRemoveScripts: false
        };
      }
    }
  }

  useEffect(() => {
    setTotalMTM(0);
    setDownMTM(0);

    {
      Object.entries(positionMap).map(([key1, mkw1]) => {
        mkw1.totalMTM = 0;
        return Object.entries(mkw1.flattened).map(([key, mkw]) => {
          
          mkw1.totalMTM += mkw.profitLoss;
          setTotalMTM((prevTotalMTM) => prevTotalMTM + mkw.profitLoss);
          if (mkw1.subBrokerPartnership && user.adminType !== 'SUBBROKER') {
            setDownMTM((prevDownMTM) => prevDownMTM + (mkw.profitLoss * (mkw1.subBrokerPartnership / 100)));
          }
        }
        )
      })
    }

  }, [flattenPositionData]);

  useEffect(() => {

    if (totalMTM === 0) {
      setSelfMTM(0);
    } else {

      if (adminPartnership === null && masterPartnership === null && brokerPartnership === null) {

        if(user.parentPercentage){
          setUpMTM(0- totalMTM * (user.parentPercentage / 100));
          setSelfMTM(0 - totalMTM - (0 - downMTM) - (0 - totalMTM * (user.parentPercentage / 100)));
        } else{
          if(user.adminType === 'SUBBROKER'){
            setSelfMTM(subBrokerPartnership ? 0-(totalMTM*subBrokerPartnership/ 100) : 0);
            setUpMTM((totalMTM*subBrokerPartnership/ 100)-totalMTM);
            setDownMTM(0);
          } else if(user.adminType === 'SUPER_ADMIN' || user.adminType == 'SUPER_MASTER'){
            setSelfMTM(0 - totalMTM - (0 - downMTM));
            setUpMTM(0);
          } else {
            setSelfMTM(0 - totalMTM - (0 - downMTM));
            setUpMTM(0);
          }
        }

      } else {
     
        var self = totalMTM;

        if (brokerPartnership) {
          self = self * brokerPartnership / 100;
        }

        if (masterPartnership) {
          self = self * masterPartnership / 100;
        }

        setUpMTM(0- self * (user.parentPercentage / 100));
        setSelfMTM(0 - (self - (self * (user.parentPercentage / 100))));
      }
    }

  }, [totalMTM]);

  useEffect(() => {
    setTotalQty(totalBuyQty - totalSellQty);
  }, [totalMTM]);

  const handleCheckboxChange = (e, key) => {
    setCheckboxState((prevState) => ({
      ...prevState,
      [key]: e.target.checked,
    }));
  };

  const handleSelectAll = (e) => {
    const newState = e.target.checked;
    setIsAllSelected(newState);

    const newCheckboxState = {};
    Object.entries(positionMap).forEach(([key1, mkw1]) => {
      Object.entries(mkw1.flattened).forEach(([key, mkw]) => {
        if(mkw.qty !== 0){
          const compositeKey = `${key1}-${key}`;
          newCheckboxState[compositeKey] = newState;
        }
      });
    });

    setCheckboxState(prev => ({ ...prev, ...newCheckboxState }));
  };

  const handleExitPosition = () => {

       Swal.fire({
                title: 'Are you sure?',
                icon: 'warning',
                showCancelButton: true,
                confirmButtonText: 'Yes ',
                cancelButtonText: 'No',
                cancelButtonColor: "#d33",
            }).then((result) => {
                if (result.isConfirmed) {

                  var selectedPositionList = [];
                  Object.entries(checkboxState).forEach(([key, isSelected]) => {
                    if (isSelected) {
                      const record = findRecordByKey(key);
                      if (record) {
                        positionList.forEach(e =>{
                          if(e.user.userid === record.userId) {
                            e.position.forEach(p=>{
                              if(p.scriptId === record.scriptId){
                                var position = {
                                  scriptId : p.scriptId,
                                  userId: record.userId,
                                  tradeBy: user.adminId,
                                  orderType: p.type === "Buy" ? "Sell-MP" : "Buy-MP",
                                  quantity: p.qty,
                                  lot: p.type === "Buy" ? p.totalBuyLot - p.totalSellLot :  p.totalSellLot - p.totalBuyLot,
                                  rate: record.ltp,
                                  inLimit: false,
                                  device: "Browser",
                                  "userAgent": navigator.userAgent
                                }
                                selectedPositionList.push(position);
                              }
                            });
                          }
                        });
                      }
                    }
                  });
                  
                  exitPositionCall(selectedPositionList);
                   
                }
              });
  };

  const exitPositionCall = (list) => {

    if(list.length > 0){
      PositionServices.exitPosition(list)
                  .then(res => {
                      if (res.code === 1) {
                          Swal.fire({
                            html: 'Orders Placed!',
                            icon: 'success',
                            color: "#fff",
                            background: "#000",
                            showCloseButton: true,
                            focusConfirm: true,
                            confirmButtonText: `OK`
                        }).then((result) => {
                          window.location.reload();
                        });

                      } else {
                        Swal.fire({
                          icon: "error",
                          text: res.messages
                        });
                      }
                  })
                  .catch(error => {
                     Swal.fire({
                            icon: 'error',
                            text: error?.response?.data?.data?.errors[0]?.errorMessage || "General system error!"
                        });
                  });

        } else {
        Swal.fire({
              icon: 'error',
              text: 'Please select record!'
          });
    }
  }

  const findRecordByKey = (k) => {
    for (const [key1, mkw1] of Object.entries(positionMap)) {
      for (const [key2, mkw] of Object.entries(mkw1.flattened)) {
        const compositeKey = `${key1}-${key2}`;
        if (compositeKey === k) {
          return mkw;
        }
      }
    }
    return null;
  };

  const handleReset = () => {
    
    setSelectedMarket( null );
    selectedMarketRef.current = null;
    setSelectedScript(null);
    selectedScriptRef.current = null;
    setSelectedAdmin(null);
    selectedAdminRef.current = null;
    setSelectedMaster(null);
    selectedMasterRef.current = null;
    setSelectedBrokerId(null);
    selectedBrokerRef.current = null;
    setSelectedSubBrokerId(null);
    selectedSubBrokerRef.current = null;
    setSelectedClient(null);
    selectedClientRef.current = null;

  };


  const handleRollover = () => {

    Swal.fire({
      title: 'Are you sure?',
      icon: 'warning',
      showCancelButton: true,
      confirmButtonText: 'Yes ',
      cancelButtonText: 'No',
      cancelButtonColor: "#d33",
   }).then((result) => {
      if (result.isConfirmed) {

        const selectedScripts = {}; // To hold userId -> array of scriptIds
        var present = false;
        Object.entries(checkboxState).forEach(([key, isSelected]) => {
          if (isSelected) {
            present = true;
            const record = findRecordByKey(key); // Get the record based on the key
            if (record) {
              const { userId, scriptId } = record; // Extract userId and scriptId
              if (!selectedScripts[userId]) {
                selectedScripts[userId] = [];
              }
              selectedScripts[userId].push(scriptId);
            }
          }
        });

        if(present) {
          // Prepare the request payload
          const requestPayload = {
            adminId: user.adminId,
            device: 'BROWSER',
            userAgent: navigator.userAgent,
            scripts: selectedScripts, // Scripts as an object with userId as key
          };

          PositionServices.rollOver(requestPayload)
            .then((res) => {
              if (res.code === 1) {
                Swal.fire({
                  html: 'Request sent successfully',
                  icon: 'success',
                  color: "#fff",
                  background: "#000",
                  showCloseButton: true,
                  focusConfirm: true,
                  confirmButtonText: `OK`
                }).then((result) => {
                  window.location.reload();
                });
              } else{
                Swal.fire({
                  icon: "error",
                  text: res.messages
                });
              }
            })
            .catch((error) => {
              Swal.fire({
                icon: 'error',
                text: error?.response?.data?.data?.errors[0]?.errorMessage || "General system error!"
            });
            });
        }  else{
          Swal.fire({
                icon: 'error',
                text: 'Please select record!'
            });
        }
      }
    });
  }
  

  const handleMarketChange = (market) => {
    setSelectedMarket(market);
     selectedMarketRef.current = market;
  }

  const handleScriptChange = (script) => {
    setSelectedScript(script);
    selectedScriptRef.current = script;
  }
  const handleScriptReset = () => {
    setSelectedScript(null);
    selectedScriptRef.current = null;
  }
  const handleFromDateChange = (newDate) => {
    setFromDate(newDate);
  }
  const handleSelectedClientChange = (selected) => {
    setSelectedClient(selected?.userId);
    selectedClientRef.current = selected?.userId;
  }

  const getPosition = (loading) => {
    setLoading(loading);
    const dataToSubmit = {
      adminId: user.adminId,
      loginId: user.adminId
    };
    
    const clientRef = selectedClientRef.current;
        if (clientRef) {
            dataToSubmit.userId =  clientRef;
            dataToSubmit.adminId = user.adminId;
        } else if (selectedBrokerRef.current != null) {
            dataToSubmit.adminId = selectedBrokerRef.current;
        } else if (selectedMasterRef.current != null) {
            dataToSubmit.adminId = selectedMasterRef.current?.value;
        } else if (selectedAdminRef.current != null) {
            dataToSubmit.adminId = selectedAdminRef.current?.value;
        }

        dataToSubmit.segment = selectedMarketRef.current;
        dataToSubmit.keyword = selectedScriptRef.current;

    PositionServices.getPosition(dataToSubmit)
      .then((resp) => {
        setLoading(false);
        if (resp.code === 1 && resp.data.positionList) {
          const pp = resp.data.positionList;

          if(status === 'ALL') {
            setPositionList([...pp]);
          } else {
            const outstandingPosition = pp
            .map(position => {
              const filtered = position.position.filter(p => p.lot !== 0);
              return filtered.length > 0 ? { ...position, position: filtered } : null;
            })
            .filter(Boolean); // Remove nulls

            flattenPositionData(outstandingPosition);
          }
         
        }
      })
      .catch((error) => { });
  };

  return (
    <div>
      <Card className="mt-0">
        <Card.Body>
          <Row>
            <Col sm={1} className="mt-0 me-4 ms-1">
              <Row>
                <Form.Check
                  inline
                  defaultChecked
                  label="ALL"
                  className="fss-05 fw-bold"
                  name="group1"
                  type="radio"
                  id="inline-radio-1"
                  checked={status === 'ALL'}
                  onChange={() => setStatus('ALL')}
                />
              </Row>

              <Row>
                <Form.Check
                  inline
                  label="OUTSTANDING"
                  className="fss-05 fw-bold"
                  name="group1"
                  type="radio"
                  id="inline-radio-2"
                  checked={status === 'OUTSTANDING'}
                  onChange={() => setStatus('OUTSTANDING')}
                />
              </Row>
            </Col>

            <Col className="mt-0">
              <Row>
                <Form.Check
                  inline
                  defaultChecked
                  label="CLIENT WISE"
                  className="fss-05 fw-bold m-0"
                  name="group2"
                  type="radio"
                  id="inline-radio-1"
                />
              </Row>

              <Row>
                <Form.Check
                  inline
                  label="SCRIPT WISE"
                  className="fss-05 fw-bold m-0"
                  name="group2"
                  type="radio"
                  id="inline-radio-2"
                />
              </Row>

              <Row>
                <Form.Check
                  inline
                  label="SELF SUMMARY"
                  className="fss-05 fw-bold m-0"
                  name="group2"
                  type="radio"
                  id="inline-radio-3"
                />
              </Row>
            </Col>

            <Col>
              <b className='fss-05'>SEGMENT</b>
              <MarketDropdown
                allScripts={allScripts}
                onMarketChange={handleMarketChange}
                onScriptReset={handleScriptReset}
                value={selectedMarket}
              />
            </Col>

            <Col>
              <b className='fss-05'>SCRIPT NAME</b>
              <ScriptDropdown
                allScripts={allScripts}
                selectedMarket={selectedMarket}
                onScriptChange={handleScriptChange}
                value={selectedScript}
              />
            </Col>

            {user.adminType == 'SUPER_ADMIN' || user.adminType == 'SUPER_MASTER' ?
              <>
                <Col>
                  <b className="fss-05">ADMIN</b>
                  <AdminDropdown
                    adminId={user.adminId}  // Pass adminId to MasterDropdown component
                    setSelectedOption={setSelectedAdmin} />
                </Col>
              </> : ""}

            {/* <Col className="col-3 me-4"></Col> */}

            {user.adminType == 'SUPER_ADMIN' || user.adminType == 'ADMIN' || user.adminType == 'SUPER_MASTER' ?
              <>
                <Col>
                  <b className="fss-05">MASTER</b>
                  <MasterDropdown
                    adminId={user.adminId}
                    selectedAdmin={selectedAdmin}
                    setSelectedOption={setSelectedMaster}
                    setSelectedMaster={setSelectedMaster}
                    setSelectedBrokerId={setSelectedBrokerId}
                  // onChange={handleSelectedMasterChange}   
                  />
                </Col>
              </> : ""}

            {user.adminType == 'SUPER_ADMIN' || user.adminType == 'ADMIN' || user.adminType == 'MASTER' || user.adminType == 'SUPER_MASTER' ?
              <>
                <Col>
                  <b className="fss-05">BROKER</b>
                  <BrokerDropdown
                    selectedAdmin={selectedAdmin}
                    selectedMaster={selectedMaster}
                    setSelectedOption={setSelectedBrokerId}
                    setSelectedBrokerId={setSelectedBrokerId}
                    setSelectedSubBrokerId={setSelectedSubBrokerId}
                  //onChange={handleSelectedBrokerChange}
                  />
                </Col>
              </> : ""}

            <Col>
              <b className="fss-05">CLIENT</b>
              <ClientDropdown
                selectedAdmin={selectedAdmin}
                selectedMaster={selectedMaster}
                selectedBrokerId={selectedBrokerId}
                selectedSubBrokerId={selectedSubBrokerId}
                setSelectedOption={handleSelectedClientChange} // Pass handler for client change
              />
            </Col>
            {/* <Col>
              <b className="fss-05">EXPIRY DATE</b><br></br>
              <From fromDate={fromDate} onDateChange={handleFromDateChange} />
            </Col> */}
          </Row>

          <Row>
            <Col sm={4} className="mt-3">
              <Button variant="success" size="sm" className="fss-06 me-3" onClick={() => getPosition(true)}>
                GET POSITION
              </Button>
              {user.adminType !== 'SUBBROKER' ? <>
                <Button variant="secondary" size="sm" className="fss-06 me-3" onClick={handleRollover}>
                  ROLLOVER
                </Button>
                <Button variant="danger" size="sm" className="fss-06 me-3" onClick={handleExitPosition}>
                  EXIT POSITION
                </Button>
                </> : ""
              }
              <Button variant="secondary" size="sm" className="fss-06" onClick={handleReset}>
                CLEAR FILTER
              </Button>
            </Col>

            <Col className="p-1 ms-5">
              <Card className="w-auto summary-card">
                <Card.Body className="pt-1 p-0">
                  <Row className="m-0">
                    <Col
                      className="text-center fss-08"
                      style={{ whiteSpace: "nowrap" }}
                    >
                      TOTAL MTM
                      <br />
                      <NumberFormatter number={totalMTM}></NumberFormatter>
                    </Col>
                  </Row>
                </Card.Body>
              </Card>
            </Col>

            <Col className="p-1">
              <Card className="w-auto summary-card">
                <Card.Body className="pt-1 p-0">
                  <Row className="m-0">
                    <Col
                      className="text-center fss-08"
                      style={{ whiteSpace: "nowrap" }}
                    >
                      SELF MTM
                      <br />
                      <NumberFormatter number={selfMTM}></NumberFormatter>
                    </Col>
                  </Row>
                </Card.Body>
              </Card>
            </Col>

            <Col className="p-1">
              <Card className="w-auto summary-card">
                <Card.Body className="pt-1 p-0">
                  <Row className="m-0">
                    <Col
                      className="text-center fss-08"
                      style={{ whiteSpace: "nowrap" }}
                    >
                      DOWNLINE MTM
                      <br />
                      <NumberFormatter number={0 - downMTM}></NumberFormatter>
                    </Col>
                  </Row>
                </Card.Body>
              </Card>
            </Col>

            <Col className="p-1">
              <Card className="w-auto summary-card">
                <Card.Body className="pt-1 p-0">
                  <Row className="m-0">
                    <Col
                      className="text-center fss-08"
                      style={{ whiteSpace: "nowrap" }}
                    >
                      UPLINE MTM
                      <br />
                      <NumberFormatter number={upMTM}></NumberFormatter>
                    </Col>
                  </Row>
                </Card.Body>
              </Card>
            </Col>

            <Col className="p-1">
              <Card className="w-auto summary-card">
                <Card.Body className="pt-1 p-0">
                  <Row className="m-0">
                    <Col
                      className="text-center fss-08"
                      style={{ whiteSpace: "nowrap" }}
                    >
                      BUY QTY
                      <br />
                      <NumberFormatter number={totalBuyQty}></NumberFormatter>
                    </Col>
                  </Row>
                </Card.Body>
              </Card>
            </Col>

            <Col className="p-1">
              <Card className="w-auto summary-card">
                <Card.Body className="pt-1 p-0">
                  <Row className="m-0">
                    <Col
                      className="text-center fss-08"
                      style={{ whiteSpace: "nowrap" }}
                    >
                      SELL QTY
                      <br />
                      <NumberFormatter number={0 - totalSellQty}></NumberFormatter>
                    </Col>
                  </Row>
                </Card.Body>
              </Card>
            </Col>

            <Col className="p-1 ">
              <Card className="w-auto summary-card">
                <Card.Body className="pt-1 p-0">
                  <Row className="m-0">
                    <Col
                      className="text-center fss-08"
                      style={{ whiteSpace: "nowrap" }}
                    >
                      TOTAL QTY
                      <br />
                      <NumberFormatter number={totalQty}></NumberFormatter>
                    </Col>
                  </Row>
                </Card.Body>
              </Card>
            </Col>
          </Row>
        </Card.Body>
      </Card>

      <Card className="mt-1 mb-5">
        <Card.Body>
          <div className="table-responsive">
            {loading ? (
              <div className="container vh-100">
                <div className="d-flex align-items-center justify-content-center h-90">
                  <div className="spinner-border text-secondary m-5" role="status" style={{ width: '4rem', height: '4rem' }}>
                    <span className="visually-hidden">Loading...</span>
                  </div>
                </div>
              </div>
            ) : (
              <Table
                id="table"
                className="table text-center table-responsive">
                <thead className='bg-secondary-row'>
                  <tr>
                    {user.adminType !== 'SUBBROKER' ? <>
                    <th>
                      <Form.Check
                        type="checkbox"
                        onChange={handleSelectAll} // Handle "select all"
                        checked={isAllSelected} // Whether all rows are selected
                        label="" // Optional label
                      /></th>
                      </>
                    :""}
                    <th className="fss-14">SEGMENT</th>
                    <th className="fss-14">CLIENT</th>
                    <th className="fss-14">SYMBOL</th>
                    <th className="fss-14">T. BUY Q.</th>
                    <th className="fss-14">BUY A. P.</th>
                    <th className="fss-14">T. SELL Q.</th>
                    <th className="fss-14">SELL A. P.</th>
                    <th className="fss-14">NET Q.</th>
                    <th className="fss-14">B.E A.</th>
                    <th className="text-end fss-14">LIVE</th>
                    <th className="text-end fss-14">MTM</th>
                    {user.adminType !== 'SUBBROKER' ?
                    <th className="fss-14">CLOSE</th> : ""}
                  </tr>
                </thead>
                <tbody className="fss-14">
                  {positionMap.length === 0 ?

                    <tr>
                      <td colSpan="14" className="text-center">No data available</td>
                    </tr>
                    :(
                    <>
                    {Object.entries(positionMap).map(([key1, mkw1]) => {
                      var row = Object.entries(mkw1.flattened).map(([key, mkw]) => (
                        <tr key={`${key1}-${key}`} className={mkw.qty !== '' ? mkw.qty < 0 ? 'sell-row' : 'buy-row' : ''}>
                          {user.adminType !== 'SUBBROKER' ? <>
                          <td>
                            {mkw.qty !== 0 ?
                                  <Form.Check
                                    type="checkbox"
                                    className="mb-0"
                                    onChange={(e) => handleCheckboxChange(e, `${key1}-${key}`)}  
                                    checked={checkboxState[`${key1}-${key}`]  || false}  
                                    label=""
                                  />
                                 :"" 
                          } </td></> : ""}
                          <td> {mkw.segment}</td>
                          <td className="text-nowrap"> {mkw.client}</td>
                          <td className="text-nowrap"> {mkw.scriptName}</td>
                          <td className="text-nowrap"> {mkw.totalBuyQty !== '' ? (<span className="d-flex justify-content-center align-items-center">  {mkw.totalBuyQty} (<NumberFormatter number={mkw.totalBuyLot} />)</span>) : ''}</td>
                          <td> {mkw.scriptId !== '' ? mkw.totalBuy > 0 ? <NumberFormatter number={mkw.totalBuy / mkw.totalBuyQty}></NumberFormatter> : '0.00' : ''}</td>
                          <td className="text-nowrap"> {mkw.totalSellQty !== '' ?  (<span className="d-flex justify-content-center align-items-center">  {mkw.totalSellQty} (<NumberFormatter number={mkw.totalSellLot}/>)</span>) : ''}</td>
                          <td> {mkw.scriptId !== '' ? mkw.totalSell > 0 ? <NumberFormatter number={mkw.totalSell / mkw.totalSellQty}></NumberFormatter> : '0.00' : ''}</td>
                          <td> {mkw.scriptId !== '' ?
                            <span className={(mkw.qty) >= 0 ? 'positive-amout-color d-flex justify-content-center align-items-center' : "nagative-amout-color d-flex justify-content-center align-items-center"}  >{(mkw.totalBuyQty - mkw.totalSellQty) + '('} <NumberFormatter number={mkw.totalBuyLot - mkw.totalSellLot}></NumberFormatter>{')'}</span>
                            : ''}</td>
                          <td> {mkw.scriptId !== '' ? mkw.bea > 0 ? <NumberFormatter number={mkw.bea}></NumberFormatter> : '0.00' : ''}</td>
                          <td className="text-end"> {mkw.scriptId !== '' ? <NumberFormatter number={mkw.ltp}></NumberFormatter> : mkw.ltp}</td>
                          <td className="text-end">
                            <span className={mkw.profitLoss < 0 ? 'nagative-amout-color' : 'positive-amout-color'}>
                              {mkw.profitLoss !== null ? <NumberFormatter number={mkw.profitLoss}></NumberFormatter> : 0}
                            </span>
                          </td>
                          {user.adminType !== 'SUBBROKER' ?
                          <td> {mkw.scriptId !== '' && mkw.qty != 0 ? <span className="fa fa-close nagative-amout-color" style={{ cursor: "pointer" }}
                            size="sm"
                            onClick={(e)=> handleExitClick(e, mkw)} ></span> : ''}</td> : ""}
                        </tr>
                      ));

                      row.push(
                        <tr key={`summary-${key1}`} className="summary-row white-row">
                          {user.adminType !== 'SUBBROKER' ?
                          <td></td> : ""}
                          
                           {/*<td colSpan={9}></td> 
                            <td></td>
                          <td></td> <td></td> <td></td>
                          <td></td> <td></td> <td></td>
                          <td></td> */}
                          <td colSpan={10} className="text-black text-end text-nowrap">{mkw1.name}</td>
                          <td className="text-end"> <span className={mkw1.totalMTM < 0 ? 'nagative-amout-color' : 'positive-amout-color'}>
                            <NumberFormatter number={mkw1.totalMTM}></NumberFormatter></span>
                          </td>
                          {user.adminType !== 'SUBBROKER' ?
                          <td></td> : ""}
                        </tr>
                      );
                      return row;
                    })}

                    <tr className="summary-row white-row">
                    {user.adminType !== 'SUBBROKER' ?<td></td> : ""} <td></td> <td></td>
                          <td></td> <td></td> <td></td>
                          <td></td> <td></td> <td></td>
                          <td></td>
                          <td className="text-black text-end">TOTAL</td>
                          <td className="text-end"> <span className={totalMTM < 0 ? 'nagative-amout-color' : 'positive-amout-color'}>
                            <NumberFormatter number={totalMTM}></NumberFormatter></span>
                          </td>
                          {user.adminType !== 'SUBBROKER' ?
                          <td></td> : ""}
                        </tr>
                  </> 
                  )}
                </tbody>
              </Table>
              
            )}
          </div>
        </Card.Body>
      </Card>

      <Modal show={showPositionModal} onHide={handlePositionModalClose}>
                  <Modal.Header closeButton>
                    <Modal.Title>CLOSE POSITION</Modal.Title>
                  </Modal.Header>
                  <Modal.Body>
                  
                    {selectedRowData && (
                      <>
                        <lable className="fss-08">CLIENT:  {selectedRowData.client}</lable><br></br>
                        <lable className="fss-08">SCRIPT:  {selectedRowData.scriptName}</lable>
                        <Row className='mt-1'>
                          <Col>
                            {["radio"].map((type) => (
                              <div key={`inline-${type}`}>
                                <Form.Check
                                  inline
                                  label="MARKET"
                                  className="fss-08 custom-radio"
                                  name="group3"
                                  type={type}
                                  checked={orderType === "MARKET"}
                                  onChange={() => handleRadioSelection("MARKET")}
                                />
                                <Form.Check
                                  inline
                                  label="LIMIT"
                                  className="fss-08 custom-radio"
                                  name="group3"
                                  type={type}
                                  checked={orderType === "LIMIT"}
                                  onChange={() => handleRadioSelection("LIMIT")}
                                />
                              </div>
                            ))}
                          </Col>
                        </Row>
                        <Row className='mt-1'>
                          <Col>
                            <label className="fss-08">LOT</label>
                            <Form.Control
                              type="number"
                              value={selectedRowData.lot !== null ? String(selectedRowData.lot).includes('.') ? Number(selectedRowData.lot).toFixed(2)
                               :  selectedRowData.lot : '' }
                              theme={the}
                              styles={customStyles}
                              className='bg-light text-black'
                              onChange={(e) => onLotchange(e)}
                            />
                          </Col>
                          <Col>
                            <label className="fss-08">QTY</label>
                            {selectedRowData.segment === "MCX"?
                            <Form.Control
                              type="number"
                              value={selectedRowData.qty}
                              theme={the}
                              styles={customStyles}
                              className='bg-light text-black'
                              readOnly
                            /> : 
                            <Form.Control
                              type="number"
                              step="1"
                              value={selectedRowData.qty}
                              theme={the}
                               inputMode="numeric"
                              styles={customStyles}
                              className='bg-light text-black'
                              onChange={(e) => onQtychange(e)}
                            />
                            }
                          </Col>
                        </Row>
                        <Row className='mt-2'>
                          <Col>
                            <label className="fss-08">PRICE</label>
                            {orderType === "MARKET" ?
                              <Form.Control
                                type="number"
                                value={selectedRowData.ltp}
                                theme={the}
                                styles={customStyles}
                                readOnly
                                className='bg-light text-black'
                              /> 
                              :
                              <Form.Control
                                type="number"
                                value={selectedRowData.ltp}
                                theme={the}
                                styles={customStyles}
                                className='bg-light text-black'
                                onChange={(e) =>
                                  setSelectedRowData({ ...selectedRowData, ltp: e.target.value })
                                }
                            /> 
                            }
                          </Col>
                        </Row>
      
                        <Row className="mt-2">
                          <Col className="text-end">
                          <Button className="ps-4 pe-4" variant={selectedRowData.type === "Sell" ? "success" : "danger"}  onClick={handleBuySell}>
                           {selectedRowData.type === "Sell" ? "Buy" : "Sell"}
                          </Button>
                          </Col>
                        </Row>
      
                        </>
                    )}
      
                  </Modal.Body>
                </Modal>
                

    </div>
  );
}
export default Position;
